import { PushNotificationsView } from '@/views/PushNotificationsView';
import { MainLayout } from '@/widgets/layouts/MainLayout';

const PushNotificationsPage = () => (
  <MainLayout meta={{ title: 'Push Notifications' }}>
    <PushNotificationsView />
  </MainLayout>
);

export default PushNotificationsPage;
